export default __webpack_public_path__ + "static/media/3.c5716f22.jpg";